import React from "react";
import { motion } from "framer-motion";

export default function WhyItWorks() {
  return (
    <section>
      <div className="py-20 md:py-28" style={{ background: "#D7FF37" }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2
              className="font-bold mb-8"
              style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)", color: "#121212" }}
            >
              למה זה עובד?
            </h2>
            <p className="text-base md:text-lg leading-relaxed" style={{ color: "#121212" }}>
              כי הכוח עובר{" "}
              <span className="font-bold">מהמזל – להשתתפות</span>.
              <br />
              ככל שהקהילה שלנו גדלה, כך יכולת המיקוח
              והגישה שלנו לאירועים הגדולים בעולם
              משתפרת. אתם לא לבד בתור – אתם חלק
              מתנועה.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
